/* eslint-disable */
import { protoLib as lib } from '@tock/coretypes';

const protoDefs = require('@tock/protos/dist/core.json');
const clowncarDefs = require('@tock/protos/dist/clowncar.json');
const consumerDefs = require('@tock/protos/dist/consumer.json');
const dashboardDefs = require('@tock/protos/dist/dashboard.json');
const messagingDefs = require('@tock/protos/dist/messaging.json');

lib.define('tocktix.messages').addJSON(protoDefs.nested.tocktix.nested.messages.nested);
lib
  .define('tocktix.proto.dashboard')
  .addJSON(dashboardDefs.nested.tocktix.nested.proto.nested.dashboard.nested);
lib
  .define('tocktix.proto.clowncar')
  .addJSON(clowncarDefs.nested.tocktix.nested.proto.nested.clowncar.nested);
lib
  .define('tocktix.proto.consumer')
  .addJSON(consumerDefs.nested.tocktix.nested.proto.nested.consumer.nested);
lib.define('tocktix.proto.messaging').addJSON(messagingDefs.nested.tocktix.nested.messaging.nested);
const resolvedRoot = lib.resolveAll();
export default {
  ...resolvedRoot.lookup('tocktix.proto.clowncar'),
  ...resolvedRoot.lookup('tocktix.proto.consumer'),
  ...resolvedRoot.lookup('tocktix.proto.dashboard'),
  ...resolvedRoot.lookup('tocktix.proto.messaging'),
  ...resolvedRoot.lookup('tocktix.messages'),
} as any;
